import { createSvgIconComponent } from "../utils";

export const IconTwitter = createSvgIconComponent({
  viewBox: "0 0 16 16",
  paths: [
    {
      d: "M16 3.25c-.58.26-1.07.27-1.59 0 .67-.4.7-.67.94-1.43-.62.37-1.32.64-2.05.79a3.24 3.24 0 0 0-5.52 2.95A9.2 9.2 0 0 1 1.1 2.18a3.23 3.23 0 0 0 1 4.32 3.23 3.23 0 0 1-1.47-.4v.04a3.24 3.24 0 0 0 2.6 3.17c-.47.13-.97.15-1.46.06a3.24 3.24 0 0 0 3.03 2.25A6.51 6.51 0 0 1 0 12.96a9.17 9.17 0 0 0 4.97 1.46c5.95 0 9.21-4.94 9.21-9.22v-.42c.63-.46 1.39-.88 1.82-1.53z",
    },
  ],
});
